import { useCallback, useState } from 'react'
import cameraModelApiService from '../api/camera-model.api'
import { CameraModel } from 'domain/camera-model'
import { useToast } from 'layout/context/toast-context'
import { AxiosError } from 'axios'
import { ApiErrorResponse } from 'http/types/api-error-response'

interface UseCameraModelHookReturn {
  cameraModels: CameraModel[]
  isLoading: boolean
  error: Error | null
  fetchCameraModels: () => Promise<void>
}

export const useCameraModel = (): UseCameraModelHookReturn => {
  const { showError } = useToast()
  const [cameraModels, setCameraModels] = useState<CameraModel[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  const fetchCameraModels = useCallback(async (): Promise<void> => {
    setIsLoading(true)
    setError(null)

    await cameraModelApiService
      .getCameraModels()
      .then((response) => {
        setCameraModels(response.responseObject)
      })
      .catch((error: AxiosError) => {
        const err = error.response?.data as ApiErrorResponse | undefined

        if (err?.error && err?.message) {
          showError(err.error, err.message)
        } else if (!error.response) {
          showError('Erro de conexão', 'Serviço temporariamente indisponível')
        }
        setError(error as Error)
        setCameraModels([])
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [showError])

  return {
    cameraModels,
    isLoading,
    error,
    fetchCameraModels,
  }
}
